/* =========================================================================
     CUSTOM SIZE ESTIMATOR FORM AUTO-SYNC
  ========================================================================= */
(function () {
    let customSizeRecordId = null;
    let customSizeDebounceTimer = null;
    let isCustomSizeCreating = false;
    let customSizeCreationPromise = null;

    window.resetCustomSizeRecordId = function () {
        clearTimeout(customSizeDebounceTimer);
        customSizeRecordId = null;
    };

    // Called on modal CLOSE — stop any pending sync and flag the record (if any)
    // as closed/finalized so Airtable reflects this prospect session is done
    // rather than silently abandoned.
    window.finalizeCustomSizeRecord = function () {
        clearTimeout(customSizeDebounceTimer);
        const recordId = customSizeRecordId;
        customSizeRecordId = null;
        if (!recordId) return;

        try {
            fetch('https://webhooks.codeblue.agency/api/custom-size/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                keepalive: true,
                body: JSON.stringify({
                    record_id: recordId,
                    status: 'complete',
                    project: 'SignMakerz'
                })
            }).then(function (response) {
                return response.json().catch(function () { return null; });
            }).then(function (result) {
                console.log('[Custom Size Sync] Finalized Airtable Record ID:', recordId, result);
            }).catch(function (err) {
                console.error('[Custom Size Sync Finalize Exception]:', err);
            });
        } catch (err) {
            console.error('[Custom Size Sync Finalize Exception]:', err);
        }
    };

    // Called after add-size-variant successfully completes — flags the
    // Airtable record with sent_to_at so the backend can branch on its presence.
    window.markCustomSizeSentToAt = function () {
        const recordId = customSizeRecordId;
        if (!recordId) return;

        try {
            fetch('https://webhooks.codeblue.agency/api/custom-size/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                keepalive: true,
                body: JSON.stringify({
                    record_id: recordId,
                    sent_to_at: true,
                    project: 'SignMakerz'
                })
            }).then(function (response) {
                return response.json().catch(function () { return null; });
            }).then(function (result) {
                console.log('[Custom Size Sync] Marked sent_to_at for Airtable Record ID:', recordId, result);
            }).catch(function (err) {
                console.error('[Custom Size Sync sent_to_at Exception]:', err);
            });
        } catch (err) {
            console.error('[Custom Size Sync sent_to_at Exception]:', err);
        }
    };

    // Visitor location saved to localStorage by theme.liquid
    function getStoredLocation() {
        try {
            return localStorage.getItem('location') || '';
        } catch (e) {
            return '';
        }
    }

    // Function to gather input values from the Custom Size Estimator Form
    function getCustomSizeFormData() {
        const activeTab = document.querySelector('.smz-type-tab.active, .smz-sign-type-active');
        let signTypeVal = (typeof SMZ !== 'undefined' && SMZ.type) ? SMZ.type : '';
        if (!signTypeVal && activeTab) {
            signTypeVal = activeTab.getAttribute('data-type') || activeTab.value || activeTab.textContent;
        }
        if (typeof smzGetApiSignType === 'function' && signTypeVal) {
            signTypeVal = smzGetApiSignType(signTypeVal) || signTypeVal;
        }

        // SMZ.staged is the modal's own source of truth: it holds the
        // width/height/price for whichever selection (preset OR a fetched
        // custom quote) is currently valid, and the modal nulls it out the
        // instant that selection is invalidated — dims edited, style/type
        // switched, or the modal reopened (see smzOnInput/smzSelectType/
        // smzOpen in size-variant-custom-size.liquid). Reading from it keeps
        // us in lockstep with that invalidation instead of trusting a
        // separate global that never gets cleared.
        const staged = (typeof SMZ !== 'undefined' && SMZ.staged) ? SMZ.staged : null;

        const wEl = document.getElementById('smzWidth') || document.querySelector('#width-in, input[name="width_in"], input[name="width"]');
        const hEl = document.getElementById('smzHeight') || document.querySelector('#height-in, input[name="height_in"], input[name="height"]');
        // Presets clear the visible width/height inputs and store the
        // dimensions on SMZ.staged instead, so that must be checked before
        // falling back to SMZ.width/height (which only track manually-typed
        // custom dimensions).
        const widthVal = (wEl && wEl.value)
            ? parseFloat(wEl.value)
            : (staged && staged.width != null ? staged.width : ((typeof SMZ !== 'undefined' && SMZ.width) ? SMZ.width : null));
        const heightVal = (hEl && hEl.value)
            ? parseFloat(hEl.value)
            : (staged && staged.height != null ? staged.height : ((typeof SMZ !== 'undefined' && SMZ.height) ? SMZ.height : null));

        const stagedPrice = staged && staged.price != null ? staged.price : null;
        const finalPriceElement = document.querySelector('#smzLivePrice, #smzPriceValue, #final-price, .smz-final-price, [data-final-price]');
        // No window.lastCalculatedFinalPrice fallback here on purpose — that
        // global is set once per successful preset pick/price fetch and
        // never invalidated, so using it would resend a previous selection's
        // price after the customer changed dimensions/type or reopened the
        // modal. When neither SMZ.staged nor the live-price display has a
        // value, no price has been confirmed for the current input yet.
        const finalPriceVal = stagedPrice != null
            ? stagedPrice
            : (finalPriceElement ? finalPriceElement.textContent || finalPriceElement.value : null);

        return {
            type_of_sign: signTypeVal ? String(signTypeVal).trim() : '',
            width_in: widthVal ? parseFloat(widthVal) : null,
            height_in: heightVal ? parseFloat(heightVal) : null,
            final: finalPriceVal ? parseFloat(String(finalPriceVal).replace(/[^0-9.]/g, '')) : null,
            location: getStoredLocation(),
            payment_url: window.location.href,
            project: 'SignMakerz'
        };
    }

    // Function to sync data to backend (Create or Update)
    async function syncCustomSizeData() {
        if (isCustomSizeCreating && customSizeCreationPromise) {
            try {
                await customSizeCreationPromise;
            } catch (e) {
                // Ignore initial creation error, will retry or update
            }
        }

        const data = getCustomSizeFormData();

        // Do not sync if minimal dimension or sign type data is absent
        if (!data.type_of_sign && !data.width_in && !data.height_in) {
            return;
        }

        const doFetch = async () => {
            const isUpdate = Boolean(customSizeRecordId);
            const endpoint = isUpdate
                ? 'https://webhooks.codeblue.agency/api/custom-size/update'
                : 'https://webhooks.codeblue.agency/api/custom-size/create';

            const payload = {
                ...data,
                project: 'SignMakerz'
            };
            if (isUpdate && customSizeRecordId) {
                payload.record_id = customSizeRecordId;
            }

            try {
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();

                if (response.ok && result.success) {
                    if (!customSizeRecordId && result.record_id) {
                        customSizeRecordId = result.record_id;
                        console.log('[Custom Size Sync] Created Airtable Record ID:', customSizeRecordId);
                    } else {
                        console.log('[Custom Size Sync] Updated Airtable Record ID:', customSizeRecordId);
                    }
                    return result;
                } else {
                    console.error('[Custom Size Sync Error]:', result);
                }
            } catch (err) {
                console.error('[Custom Size Sync Exception]:', err);
            }
        };

        const initialRecordId = customSizeRecordId;
        if (!initialRecordId && !isCustomSizeCreating) {
            isCustomSizeCreating = true;
            customSizeCreationPromise = doFetch().finally(() => {
                isCustomSizeCreating = false;
                customSizeCreationPromise = null;
            });
            return customSizeCreationPromise;
        } else {
            return doFetch();
        }
    }

    // Debounced listener (Fast 500ms initial creation, 2-second update debounce)
    function handleCustomSizeInput() {
        clearTimeout(customSizeDebounceTimer);
        const delay = customSizeRecordId ? 2000 : 500;
        customSizeDebounceTimer = setTimeout(() => {
            syncCustomSizeData();
        }, delay);
    }

    // Global Event Delegation for Custom Size Estimator Form inputs
    document.addEventListener('input', (e) => {
        if (e.target && (e.target.id === 'smzWidth' || e.target.id === 'smzHeight' || e.target.closest('#smzModal, #smzOverlay, .smz-card'))) {
            handleCustomSizeInput();
        }
    });

    document.addEventListener('change', (e) => {
        if (e.target && (e.target.id === 'smzWidth' || e.target.id === 'smzHeight' || e.target.closest('#smzModal, #smzOverlay, .smz-card'))) {
            handleCustomSizeInput();
        }
    });

    document.addEventListener('click', (e) => {
        if (e.target && (e.target.closest('.smz-type-tab, .smz-preset, #smzGetPrice, #smzPresetGrid'))) {
            handleCustomSizeInput();
        }
    });

    // Global helper if price API calculation finishes asynchronously:
    window.triggerCustomSizeAutoSync = function (finalPrice) {
        if (finalPrice) {
            window.lastCalculatedFinalPrice = finalPrice;
        }
        handleCustomSizeInput();
    };
})();